import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  font-family: "Righteous";
  font-size: 28px;
  color: #fff;
  position: absolute;
  margin: 25px 0px 0px 25px;
  img {
    margin-right: 4px;
    max-width: 40px;
  }
`;
